// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"30bf0ae6","282":"bc176e99","609":"dc502176","638":"70315108","658":"46fe9fd3","732":"2443f1c6"}[chunkId] + ".chunk.js";
};